import React from 'react';
import { FocGapModal } from '~/components/Patient';
import { ServicesContext } from '~/services';
import { handleButtonKeypress } from '~/util';

interface NotePCMFocProps {
    entity: NoteType | ReminderType;
    gap?: null | GapType;
    patientId: number;
}
export function NotePCMFoc({ entity, gap, patientId }: NotePCMFocProps) {
    const context = React.useContext(ServicesContext);
    const [modalOpen, setModalOpen] = React.useState(false);
    if (entity.foc_gap && gap && !context.user.hasFeatureToggle('hidden_foc')) {
        return (
            <>
                <div
                    className="d-inline-block fw-bold link-text"
                    onKeyUp={(e) => handleButtonKeypress(e, () => setModalOpen(true))}
                    onClick={() => setModalOpen(true)}
                    role="button"
                    tabIndex={0}
                >
                    {entity.foc_gap?.measure
                        ? entity.foc_gap.measure?.short_name
                        : gap?.measure?.short_name}
                </div>
                {modalOpen && (
                    <FocGapModal
                        focGap={gap}
                        patientId={patientId}
                        handleClose={() => setModalOpen(false)}
                    />
                )}
            </>
        );
    }
    return <span className="fw-bold">{entity?.foc_gap?.measure?.short_name}</span>;
}
